export const isFieldFilled = (item: unknown): boolean => {
  return item !== "" && item !== null && typeof item !== "undefined";
};
